import { TopBanner as ITopBanner } from 'modules/strapi/types';

import { TopBanner } from './components/TopBanner';
import { useTopBannersRef } from './hooks/useTopBannersRef';
import { useTopBannersStyles } from './useTopBannersStyles';

export interface TopBannersProps {
  banners: ITopBanner[];
}

export const TopBanners = ({ banners }: TopBannersProps) => {
  const refCallback = useTopBannersRef();

  const { classes } = useTopBannersStyles();

  return (
    <div className={classes.root} ref={refCallback}>
      {banners.map((banner, index) => {
        const isFirst = index === 0;
        const variant = isFirst && banners.length > 1 ? 'light' : 'dark';

        return (
          <TopBanner id={banner.id} variant={variant} key={banner.id}>
            {banner.text}
          </TopBanner>
        );
      })}
    </div>
  );
};
